export default {
  casLogin: '/udb/lgn/cas/callback.do',

  /** 登出 */
  logout: '/udb/lgn/login/logout.do',
}
